import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'acl-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;
  @Input() active: boolean;

  constructor() { }

  ngOnInit() {
  }

}
